import { Group, Stack, Text } from '@mantine/core'
import { HowToPlayBullet } from '../shared/howToPlayShared'

export function SprintHowToPlay() {
  return (
    <Stack gap={24} align="flex-start" ff="Tilt Neon, sans-serif" w={290}>
      <Stack gap={6} ta="center" lh={1.3} align="center" justify="center" w="100%" mb={12}>
        <Text fz={16} ta="center" opacity={0.7}>
          Play 10 boards.
        </Text>
        <Text fz={16} ta="center" opacity={0.7}>
          One word per board.
        </Text>
      </Stack>

      <Stack gap={12}>
        <HowToPlayBullet>Scoring is unlimited:</HowToPlayBullet>
        <Stack gap={6} pl={0}>
          <Group gap={5} align="baseline">
            <Text fz={16} ta="center" opacity={0.7}>
              3-letter words:{' '}
            </Text>
            <Text span c="yellow" fw={600} fz={22}>
              1
            </Text>{' '}
          </Group>
          <Group gap={5} align="baseline">
            <Text fz={16} ta="center" opacity={0.7}>
              Additional letters: {' '}
            </Text>
            <Text span c="yellow" fw={600} fz={22}>
              +1
            </Text>{' '}
            <Text span fw={400} c="#ffef8e" fz={15}>
              (Each)
            </Text>
          </Group>
        </Stack>
      </Stack>
      <HowToPlayBullet w={260}>
        <Stack gap={4}>
          <Group gap={4}>
            Gold tiles score{' '}
            <Text span c="yellow" fw={600} fz={22} ml={2}>
              +1
            </Text>
          </Group>
          <Text span fw={400} c="#ffef8e" fz={15}>
            (Every usage)
          </Text>
        </Stack>
      </HowToPlayBullet>
    </Stack>
  )
}
